import type { GTMCustomEvent, GTMEvent } from './gtmTypes';

declare global {
  interface Window {
    dataLayer?: Array<Record<string, unknown>>;
  }
}

/**
 * Enriches every dataLayer push with `app_name: 'SkinSeoul'` to mirror
 * master's LoggerProvider, which injected `{app_name}` into every
 * `trackEvent()` via `sendGTMEvent`. Callers can still override by
 * setting their own `app_name` — the spread order below means caller
 * fields win.
 */
const APP_NAME = 'SkinSeoul';

export const dispatchGTMEvent = (eventData: GTMEvent | GTMCustomEvent): void => {
  if (typeof window === 'undefined') {
    return;
  }

  // No GTM container loaded (e.g., React Native runtime that polyfills `window`
  // but never injects a GTM script). Silent no-op so the mobile app doesn't spam
  // debug logs or attempt a push on a non-existent queue.
  if (!window.dataLayer) {
    return;
  }

  const enriched = { app_name: APP_NAME, ...(eventData as Record<string, unknown>) };

  window.dataLayer.push(enriched);
};
